var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgD12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 33,
    viewBox: "0 0 39 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7195 0.443359H6.94514L0 6.02565V7.3241H1.10316V32.4434H4.047V9.86906H7.21314V20.346H9.29066V9.86906H29.3761V20.346H31.4536V9.86906H34.6177V32.4434H37.5615V7.3241H38.6647V6.02565L31.7195 0.443359Z",
    fill: "#777E82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.6647,
    height: 32,
    fill: "white",
    transform: "translate(0 0.443359)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD12);
export default __webpack_public_path__ + "static/media/d12.4220295ec9dd8b1351013e342400dbf2.svg";
export { ForwardRef as ReactComponent };